import { render } from "./SpacingInput.vue?vue&type=template&id=df64b048&scoped=true"
import script from "./SpacingInput.vue?vue&type=script&lang=js"
export * from "./SpacingInput.vue?vue&type=script&lang=js"

import "./SpacingInput.vue?vue&type=style&index=0&id=df64b048&lang=css"
import "./SpacingInput.vue?vue&type=style&index=1&id=df64b048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df64b048"]])

export default __exports__